import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

const Footer = () => {
	return (
		<div className="footer-w">
			<div className="os-container">
				<div className="deep-footer">
                    <p><i className="os-icon os-icon-phone"/> <a href="tel:08164855779">08164855779</a>&nbsp;<a href="tel:09068233203">09068233203</a>&nbsp;&nbsp;&nbsp;<i className="os-icon os-icon-email-2-at"/> <a href="mailto:fastcash@consumermfb.com">fastcash@consumermfb.com</a> - <a href="mailto:info@consumermfb.com">info@consumermfb.com</a><br/>Address: Aisa House, Pot 2087 Herbet Macaulay Way Wuse Zone 5, Abuja, Nigeria.</p>
                    <p>Use of this site constitutes acceptance of our <Link to="/user-agreement">User Agreement</Link> and <Link to="/privacy-policy">Privacy Policy</Link>. &copy; 2018 - {`${moment().format('YYYY')}`} fastcash.ng.</p>
                </div>
			</div>
		</div>
	);
};

export default Footer;
